// Слово подтверждения удаления аккаунта — литерал договора (`deleteAccount.body.confirm`, Р-90).
export const DELETE_CONFIRM = 'УДАЛИТЬ' as const;
